import { from } from "rxjs";
import { switchMap, take } from "rxjs/operators";
import { selectBuildingInfoByTypeId } from "../../../../selectors/selectExistingBuildingInfo";
import { selectTutorialConfig } from "../../../../selectors/selectTutorial";
import { utilBuildings } from "../../../../utils/utilBuildings";
import { actionBuildingsSelect } from "../../../player-base/buildings/actionBuildings";
export var pathSelectBuildingInBase = function (action, state$, deps) {
    return deps.inStoreDependencies.viewportChanged$.pipe(take(1), switchMap(function (viewport) {
        var state = state$.value;
        var tutorialConfig = selectTutorialConfig(state, action.tutorialStep);
        var building = selectBuildingInfoByTypeId(state, tutorialConfig.buildingId);
        var origin = utilBuildings.getCenterPositionOnScreen(building, viewport);
        return from([actionBuildingsSelect(building, origin, true)]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/restore/path/pathSelectBuildingInBase.ts
// module id = 2476
// module chunks = 3